export const getFieldFromBinary = (filters, position) => {
  // Для преобразования бинарного кода некоторых полей которые приходят с сервера
  const binaryString = Number(filters).toString(2).split('').reverse().join('');
  return parseInt(binaryString[position] || 0);
};

export const getPropsByName =(arr, propName)=>{
  return arr.map((obj)=>{
    return obj[propName];
  });
};

export const uniq = (arr)=>{
  return arr.filter((val, index, arr) => arr.indexOf(val) === index);
};
export const sortBy = (arr, fieldToSort) =>{
  return arr.sort((a, b)=>{
    if (a[fieldToSort] > b[fieldToSort]) {
      return 1;
    }
    if (a[fieldToSort] < b[fieldToSort]) {
      return -1;
    }
    return 0;
  });
};

export const upperFirst = (str) =>{
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const debounce = function(func, wait, immediate) {
  let timeout;
  return function() {
    const context = this;
    const args = arguments;
    const later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};
export const capitalise = (str) => {
  return str.charAt(0).toUpperCase() + str.substr(1);
};

export const getArbInfoForURLQuery = (arbInfo, betsHashList) =>{
  // Для декодирования информации о вилке в строку запроса. Используется для открытия калькулятора в отдельном окне
  // Возвращает урезанный обьект с минимальной инфой по вилке, чтобы не было ошибки по длине URL
  const bets = [];
  const betsIds = [arbInfo.bet1_id, arbInfo.bet2_id, arbInfo.bet3_id];
  betsIds.forEach((id)=>{
    const bet = betsHashList[id];
    bet ? bets.push(bet) : null;
  });

  return {
    id: arbInfo.id,
    arb_formula_id: arbInfo.arb_formula_id,
    arb_hash: arbInfo.arb_hash,
    bet1_id: arbInfo.bet1_id,
    bet2_id: arbInfo.bet2_id,
    bet3_id: arbInfo.bet3_id,
    bk_ids: arbInfo.bk_ids,
    created_at: arbInfo.created_at,
    event_name: arbInfo.event_name,
    sport_id: arbInfo.sport_id,
    name: arbInfo.name,
    country_id: arbInfo.country_id,
    league: arbInfo.league,
    percent: arbInfo.percent,
    middle_value: arbInfo.middle_value,
    started_at: arbInfo.started_at,
    event_id: arbInfo.event_id,
    league_id: arbInfo.league_id,
    home_id: arbInfo.home_id,
    away_id: arbInfo.away_id,
    bets: bets.map((bet)=>{
      return {
        id: bet.id,
        bookmaker_id: bet.bookmaker_id,
        commission: bet.commission,
        diff: bet.diff,
        koef: bet.koef,
        koef_lay: bet.koef_lay,
        market_depth: bet.market_depth,
        period_identifier: bet.period_identifier,
        bookmaker_league_name: bet.bookmaker_league_name,
        bookmaker_event_name: bet.bookmaker_event_name,
        team1_name: bet.team1_name,
        market_and_bet_type: bet.market_and_bet_type,
        market_and_bet_type_param: bet.market_and_bet_type_param,
        sport_id: arbInfo.sport_id,
      };
    }),
  };
};

export const getValuebetInfoForURLQuery = (valuebet, valuebetsHashList = {}) => {
  if (!valuebet) return null;

  const bets = [];
  const betIds = [valuebet.target_bookmaker_bet_id, valuebet.reference_bookmaker_bet_id];
  betIds.forEach((id)=>{
    const bet = valuebetsHashList[id];
    bet ? bets.push(bet) : null;
  });

  return {
    away_id: valuebet.away_id,
    country_id: valuebet.country_id,
    event_id: valuebet.event_id,
    event_name: valuebet.event_name,
    home_id: valuebet.home_id,
    league: valuebet.league,
    league_id: valuebet.league_id,
    league_name: valuebet.league_name,
    percent: valuebet.percent,
    sport_id: valuebet.sport_id,
    started_at: valuebet.started_at,
    target_bookmaker_bet_id: valuebet.target_bookmaker_bet_id,
    reference_bookmaker_id: valuebet.reference_bookmaker_id,
    reference_bk_margin_stripped_koef: valuebet.reference_bk_margin_stripped_koef,
    updated_at: valuebet.updated_at,
    bets: bets.map((bet)=>{
      return {
        id: bet.id || bet.target_bookmaker_bet_id,
        target_bookmaker_bet_id: bet.target_bookmaker_bet_id,
        reference_bookmaker_bet_id: bet.reference_bookmaker_bet_id,
        reference_bookmaker_id: bet.reference_bookmaker_id,
        reference_bk_margin_stripped_koef: bet.reference_bk_margin_stripped_koef,
        bookmaker_id: bet.bookmaker_id,
        commission: bet.commission,
        diff: bet.diff,
        market_depth: bet.market_depth,
        period_identifier: bet.period_identifier,
        bookmaker_event_name: bet.bookmaker_event_name,
        bookmaker_league_name: bet.bookmaker_league_name,
        team1_name: bet.team1_name,
        team2_name: bet.team2_name,
        market_and_bet_type: bet.market_and_bet_type,
        market_and_bet_type_param: bet.market_and_bet_type_param,
        sport_id: bet.sport_id,
        odds: bet.odds,
        odds_lay: bet.odds_lay,
        odds_commissed: bet.odds_commissed,
      };
    }),
  };
};

export const activeCurrencyOptions = (currencies) => {
  if (!currencies) {
    return currencies;
  }

  let inactive = [];

  try {
    const stored = JSON.parse(window.current_user?.settings || '{}').inactive_currencies;
    inactive = Array.isArray(stored) ? stored : [];
  } catch {
    inactive = [];
  }

  const kept = currencies.filter((currency) => !inactive.includes(+currency.id));

  return (kept.length ? kept : currencies).map((currency) => {
    return {
      value: currency.id,
      label: currency.code,
    };
  });
};
